import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {
    screenWidth: document.body.clientWidth,
    scrollY: window.scrollY,
    wrapH: 0,
  },
  actions: {
    update_width(context, params) {
      context.commit('UPDATE_WIDTH', params);
    },
    update_scroll(context, params) {
      context.commit('UPDATE_SCROLL', params);
    },
    update_wrap(context, params) {
      context.commit('UPDATE_WRAP', params);
    },
  },
  mutations: {
    UPDATE_WIDTH(state, payload) {
      state.screenWidth = payload;
    },
    UPDATE_SCROLL(state, payload) {
      state.scrollY = payload;
    },
    UPDATE_WRAP(state, payload) {
      state.wrapH = payload;
    },
  },
  getters: {
    screenWidth: (state) => state.screenWidth,
    scrollY: (state) => state.scrollY,
    wrapH: (state) => state.wrapH,
  },
  modules: {},
});
